import { render, staticRenderFns } from "./step-card.vue?vue&type=template&id=05065058&scoped=true"
import script from "./step-card.vue?vue&type=script&lang=js"
export * from "./step-card.vue?vue&type=script&lang=js"
import style0 from "./step-card.vue?vue&type=style&index=0&id=05065058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05065058",
  null
  
)

export default component.exports